<template>
  <v-container class="my-5">
    <h2 class="subheading grey--text">{{$t('surveys')}}</h2>
    <!-- Dialog to Create Survey -->
    <v-layout align-center justify-center fill-height>
      <v-dialog v-model="dialogCreate" persistent scrollable max-width="500">
        <template v-slot:activator="{ on }">
          <v-layout row wrap class="justify-center">
            <v-btn v-if="getProfile.role === 1 || getProfile.role === 3" color="primary" v-on="on" @click="cleanFields()" class="mr-3">
              + {{$t('add_survey')}}
            </v-btn>
            <v-btn v-if="getProfile.role === 1 || getProfile.role === 3" color="success" @click="openDialogVoting()">
              + {{$t('add_voting')}}
            </v-btn>
          </v-layout>
        </template>
        <v-form @submit.prevent="addSurvey()">
          <v-card class="elevation-5">
            <v-toolbar dark color="primary">
              <v-toolbar-title>{{$t('add_survey')}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn class="align-self-end" color="red" icon @click="dialogCreate = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-card-text>
              <v-text-field v-model="surveyData.title" autofocus :label="'*' + $t('survey_title')" :error-messages="errores.title"></v-text-field>
              <v-textarea v-model="surveyData.description" :label="$t('survey_description')" :error-messages="errores.description"></v-textarea>

              <v-menu
                v-model="menuEnd"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="surveyData.end_date"
                    :label="$t('survey_end_date')"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :error-messages="errores.end_date"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="surveyData.end_date" @input="menuEnd = false" :locale="language"></v-date-picker>
              </v-menu>
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" @click="dialogCreate = false">{{$t('cerrar')}}</v-btn>
              <v-spacer/>
              <v-btn :loading="loading" color="primary" type="submit">{{$t('crear')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-layout>

    <!-- Dialog to Create Voting -->
    <v-dialog v-model="dialogVoting" persistent scrollable max-width="600">
      <v-form @submit.prevent="addVoting()">
        <v-card class="elevation-5">
          <v-toolbar dark color="success">
            <v-toolbar-title>{{$t('add_voting')}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="align-self-end" color="red" icon @click="dialogVoting = false"><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
          <v-card-text class="pt-4">
            <v-text-field v-model="votingData.title" autofocus :label="'*' + $t('voting_title')" :error-messages="errores.title"></v-text-field>
            <v-textarea v-model="votingData.description" :label="$t('voting_description')" :error-messages="errores.description"></v-textarea>
            <v-menu v-model="menuVotingEnd" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="votingData.end_date" :label="$t('voting_end_date')" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" :error-messages="errores.end_date"></v-text-field>
              </template>
              <v-date-picker v-model="votingData.end_date" @input="menuVotingEnd = false" :locale="language"></v-date-picker>
            </v-menu>
            <v-divider class="my-4"></v-divider>
            <h3 class="mb-3">Pregunta</h3>
            <v-row>
              <v-col cols="12" md="8">
                <v-text-field v-model="votingData.question.text" label="Texto de la pregunta"></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-select v-model="votingData.question.question_type" :items="questionTypes" item-text="text" item-value="value" :label="$t('question_type')"></v-select>
              </v-col>
            </v-row>
            <div v-if="votingData.question.question_type === 'SINGLE_CHOICE' || votingData.question.question_type === 'MULTIPLE_CHOICE'" class="ml-5">
              <v-row v-for="(option, oIndex) in votingData.question.options" :key="oIndex" align="center">
                <v-col cols="10">
                  <v-text-field v-model="option.text" :label="$t('options') + ' ' + (oIndex + 1)"></v-text-field>
                </v-col>
                <v-col cols="2">
                  <v-btn icon color="red" @click="removeVotingOption(oIndex)"><v-icon>mdi-delete</v-icon></v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="addVotingOption()">+ {{$t('add_option')}}</v-btn>
              </v-row>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click="dialogVoting = false">{{$t('cerrar')}}</v-btn>
            <v-spacer/>
            <v-btn :loading="loading" color="success" type="submit">{{$t('crear')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- Dialog to Add Questions -->
    <v-dialog v-model="dialogQuestions" persistent max-width="800" scrollable>
      <v-card class="elevation-5">
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{$t('add_questions')}} - {{ selectedSurvey.title }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn class="align-self-end" color="red" icon @click="dialogQuestions = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text class="pt-4">
          <div v-for="(question, qIndex) in questionsData" :key="qIndex" class="mb-5 p-3" style="border: 1px solid #e0e0e0; border-radius: 5px;">
            <v-row>
              <v-col cols="12" md="8">
                <v-text-field v-model="question.text" :label="$t('question_text') + ' ' + (qIndex + 1)"></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-select v-model="question.question_type" :items="questionTypes" item-text="text" item-value="value" :label="$t('question_type')"></v-select>
              </v-col>
            </v-row>
            <div v-if="question.question_type === 'SINGLE_CHOICE' || question.question_type === 'MULTIPLE_CHOICE'" class="ml-5">
              <v-row v-for="(option, oIndex) in question.options" :key="oIndex" align="center">
                <v-col cols="10">
                  <v-text-field v-model="option.text" :label="$t('options') + ' ' + (oIndex + 1)"></v-text-field>
                </v-col>
                <v-col cols="2">
                  <v-btn icon color="red" @click="removeOption(qIndex, oIndex)"><v-icon>mdi-delete</v-icon></v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="addOption(qIndex)">+ {{$t('add_option')}}</v-btn>
              </v-row>
            </div>
            <v-btn color="red" class="mt-2" @click="removeQuestion(qIndex)"><v-icon>mdi-delete</v-icon> {{$t('delete_question')}}</v-btn>
          </div>
          <v-btn color="orange" @click="addQuestion()">+ {{$t('add_question')}}</v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" :loading="loading" @click="saveQuestions()">{{$t('save_questions')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog to View Results -->
    <v-dialog v-model="dialogResults" max-width="800" scrollable>
      <v-card class="elevation-5">
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{$t('survey_results')}} - {{ selectedSurvey.title }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn class="align-self-end" color="red" icon @click="dialogResults = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text class="pt-4">
          <div v-if="resultsData && resultsData.results">
            <div v-for="(res, qText) in resultsData.results" :key="qText" class="mb-4">
              <h3>{{ qText }}</h3>
              <v-simple-table v-if="!Array.isArray(res)">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">{{$t('options')}}</th>
                      <th class="text-left">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(count, optionText) in res" :key="optionText">
                      <td>{{ optionText }}</td>
                      <td>{{ count }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-list v-else dense>
                <v-list-item v-for="(textResp, idx) in res" :key="idx">
                  <v-list-item-content>
                    <v-list-item-title>• {{ textResp }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <p v-if="res.length === 0" class="grey--text">No hay respuestas</p>
              </v-list>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialogResults = false">{{$t('cerrar')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog to Preview Survey -->
    <v-dialog v-model="dialogPreview" max-width="700" scrollable>
      <v-card v-if="selectedSurvey" class="elevation-5">
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{ selectedSurvey.title }} - {{$t('survey_preview')}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn class="align-self-end" color="red" icon @click="dialogPreview = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text class="pt-5">
          <div class="mb-4 text-justify subtitle-1">
            {{ selectedSurvey.description }}
          </div>
          <v-divider class="mb-5"></v-divider>
          <div v-if="!selectedSurvey.questions || selectedSurvey.questions.length === 0" class="text-center my-5">
            <v-icon size="64" color="grey lighten-1">mdi-help-rhombus-outline</v-icon>
            <h3 class="grey--text mt-3">{{$t('msg_no_questions_yet')}}</h3>
          </div>
          <v-form v-else>
            <div v-for="(question, index) in selectedSurvey.questions" :key="question.id" class="mb-6">
              <h3 class="font-weight-medium mb-3">{{ index + 1 }}. {{ question.text }}</h3>
              <div v-if="question.question_type === 'SINGLE_CHOICE'" class="ml-4">
                <v-radio-group column>
                  <v-radio
                    v-for="option in question.options"
                    :key="option.id"
                    :label="option.text"
                    :value="option.id"
                    color="primary"
                    disabled
                  ></v-radio>
                </v-radio-group>
              </div>
              <div v-if="question.question_type === 'MULTIPLE_CHOICE'" class="ml-4">
                <v-checkbox
                  v-for="option in question.options"
                  :key="option.id"
                  :label="option.text"
                  :value="option.id"
                  color="primary"
                  hide-details
                  class="mt-1"
                  disabled
                ></v-checkbox>
              </div>
              <div v-if="question.question_type === 'TEXT'" class="ml-4">
                <v-textarea
                  outlined
                  auto-grow
                  rows="2"
                  :label="language === 'es' ? 'Tu respuesta' : 'Your answer'"
                  disabled
                ></v-textarea>
              </div>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialogPreview = false">{{$t('cerrar')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Surveys List -->
    <v-row class="mt-2 mb-0">
      <v-col cols="12" sm="4">
        <v-select
          v-model="filterType"
          :items="filterOptions"
          label="Filtrar por tipo"
          dense
          outlined
          hide-details
        ></v-select>
      </v-col>
    </v-row>
    <v-layout class="my-4" align-center justify-center fill-height>
      <v-container fluid>
        <v-row dense>
          <v-col v-for="survey in filteredSurveys" :key="survey.id" cols="12" md="6">
            <v-card class="mb-3" :color="survey.is_voting ? '#A7C7E7' : '#E8F5E9'">
              <v-card-title>{{ survey.title }}</v-card-title>
              <v-card-subtitle>{{ survey.description }}</v-card-subtitle>
              <v-card-text>
                <p><strong>{{$t('survey_start_date')}}:</strong> {{ formatDate(survey.start_date) }}</p>
                <p><strong>{{$t('survey_end_date')}}:</strong> {{ formatDate(survey.end_date) }}</p>
                <v-switch
                  v-model="survey.is_active"
                  :label="survey.is_active ? $t('activar') : $t('desactivar')"
                  color="success"
                  dense
                  @change="toggleStatus(survey)"
                ></v-switch>
                <v-chip class="ml-2" color="blue" dark small>{{ survey.questions ? survey.questions.length : 0 }} {{$t('survey_questions')}}</v-chip>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-tooltip bottom v-if="!survey.is_voting">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon color="blue" v-bind="attrs" v-on="on" @click="openQuestionsDialog(survey)">
                      <v-icon>mdi-help-box-multiple</v-icon>
                    </v-btn>
                  </template>
                  <span>{{$t('add_questions')}}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon color="orange" v-bind="attrs" v-on="on" @click="previewSurvey(survey)">
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>{{$t('survey_preview')}}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon color="green" v-bind="attrs" v-on="on" @click="viewResults(survey)">
                      <v-icon>mdi-chart-bar</v-icon>
                    </v-btn>
                  </template>
                  <span>{{$t('survey_results')}}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon color="purple" v-bind="attrs" v-on="on" @click="downloadPDF(survey)">
                      <v-icon>mdi-file-pdf-box</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('download_pdf') || 'Descargar PDF' }}</span>
                </v-tooltip>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="filteredSurveys.length === 0">
           <v-col cols="12" class="text-center grey--text">
             {{$t('ningun_resultado_1')}} {{$t('surveys')}} {{$t('ningun_resultado_2')}}
           </v-col>
        </v-row>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import { mapGetters, mapState } from 'vuex'
import JsPDF from 'jspdf'
import 'jspdf-autotable'
import Chart from 'chart.js'

export default {
  name: 'SurveyAdmin',
  data () {
    return {
      surveys: [],
      loading: false,
      dialogCreate: false,
      dialogQuestions: false,
      dialogResults: false,
      filterType: 'all',
      dialogPreview: false,
      dialogVoting: false,
      menuVotingEnd: false,
      votingData: {
        title: '',
        description: '',
        end_date: '',
        question: {
          text: '',
          question_type: 'SINGLE_CHOICE',
          options: [{ text: '', order: 1 }, { text: '', order: 2 }]
        }
      },
      surveyData: {
        title: '',
        description: '',
        start_date: '',
        end_date: '',
        is_active: true
      },
      menuStart: false,
      menuEnd: false,
      errores: {},
      selectedSurvey: {},
      questionsData: [],
      resultsData: {}
    }
  },
  computed: {
    ...mapGetters(['getProfile']),
    ...mapState(['language']),
    questionTypes () {
      return [
        { text: this.$t('SINGLE_CHOICE'), value: 'SINGLE_CHOICE' },
        { text: this.$t('MULTIPLE_CHOICE'), value: 'MULTIPLE_CHOICE' },
        { text: this.$t('TEXT'), value: 'TEXT' }
      ]
    },
    filterOptions () {
      return [
        { text: 'Todos', value: 'all' },
        { text: this.$t('surveys') || 'Encuestas', value: 'survey' },
        { text: this.$t('voting') || 'Votaciones', value: 'voting' }
      ]
    },
    filteredSurveys () {
      if (this.filterType === 'survey') {
        return this.surveys.filter(s => !s.is_voting)
      } else if (this.filterType === 'voting') {
        return this.surveys.filter(s => s.is_voting)
      }
      return this.surveys
    }
  },
  created () {
    this.getSurveys()
  },
  methods: {
    formatDate (dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleDateString()
    },
    cleanFields () {
      this.surveyData = {
        title: '',
        description: '',
        start_date: '',
        end_date: '',
        is_active: true
      }
      this.errores = {}
    },
    getSurveys () {
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/admin/surveys/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.surveys = response.data
        })
        .catch(error => {
          console.error(error)
        })
    },
    openDialogVoting () {
      this.votingData = {
        title: '',
        description: '',
        end_date: '',
        question: {
          text: '',
          question_type: 'SINGLE_CHOICE',
          options: [{ text: '', order: 1 }, { text: '', order: 2 }]
        }
      }
      this.errores = {}
      this.dialogVoting = true
    },
    addVotingOption () {
      this.votingData.question.options.push({ text: '', order: this.votingData.question.options.length + 1 })
    },
    removeVotingOption (index) {
      this.votingData.question.options.splice(index, 1)
    },
    addVoting () {
      if (!this.votingData.title || this.votingData.title.trim() === '') {
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', 'El título de la votación es requerido')
        return
      }
      if (!this.votingData.question.text || this.votingData.question.text.trim() === '') {
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', 'El texto de la pregunta es requerido')
        return
      }
      if (this.votingData.question.question_type === 'SINGLE_CHOICE' || this.votingData.question.question_type === 'MULTIPLE_CHOICE') {
        if (!this.votingData.question.options || this.votingData.question.options.length < 2) {
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', 'Debes añadir al menos 2 opciones a la pregunta')
          return
        }
        for (let i = 0; i < this.votingData.question.options.length; i++) {
          if (!this.votingData.question.options[i].text || this.votingData.question.options[i].text.trim() === '') {
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', `La opción ${i + 1} no puede estar vacía`)
            return
          }
        }
      }

      this.loading = true
      this.errores = {}
      const d = new Date()
      const startDateStr = d.toISOString().split('T')[0] + 'T00:00:00Z'
      let endDateStr = ''
      if (this.votingData.end_date) endDateStr = this.votingData.end_date + 'T23:59:59Z'

      const data = {
        title: this.votingData.title,
        description: this.votingData.description,
        is_active: false,
        is_voting: true,
        start_date: startDateStr,
        end_date: endDateStr
      }

      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/admin/surveys/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: data
      }
      axios(config)
        .then(response => {
          const newSurvey = response.data
          let parsedQ = {
            text: this.votingData.question.text,
            question_type: this.votingData.question.question_type,
            order: 1
          }
          if (parsedQ.question_type === 'SINGLE_CHOICE' || parsedQ.question_type === 'MULTIPLE_CHOICE') {
            parsedQ.options = this.votingData.question.options.map((o, idx) => ({ text: o.text, order: idx + 1 }))
          }
          const qConfig = {
            method: 'post',
            url: `https://residencial-services.intrare.app/admin/surveys/${newSurvey.id}/add_questions/`,
            headers: {
              'Content-Type': 'application/json',
              'Accept-Language': this.language,
              'authorization': 'Token ' + store.getters.getToken
            },
            data: { questions: [parsedQ] }
          }
          return axios(qConfig)
        })
        .then(() => {
          this.loading = false
          this.dialogVoting = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', 'Votación añadida correctamente')
          this.getSurveys()
        })
        .catch(error => {
          this.loading = false
          if (error.response && error.response.status === 400) {
            this.errores = error.response.data
          } else {
            console.error(error)
          }
        })
    },
    addSurvey () {
      this.loading = true
      this.errores = {}
      const d = new Date()
      const startDateStr = d.toISOString().split('T')[0] + 'T00:00:00Z'
      let data = {
        title: this.surveyData.title,
        description: this.surveyData.description,
        is_active: false,
        start_date: startDateStr
      }
      if (this.surveyData.end_date) data.end_date = this.surveyData.end_date + 'T23:59:59Z'

      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/admin/surveys/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: data
      }
      axios(config)
        .then(response => {
          this.loading = false
          this.dialogCreate = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('msg_added_survey'))
          this.getSurveys()
        })
        .catch(error => {
          this.loading = false
          if (error.response && error.response.status === 400) {
            this.errores = error.response.data
          }
        })
    },
    toggleStatus (survey) {
      const config = {
        method: 'patch',
        url: `https://residencial-services.intrare.app/admin/surveys/${survey.id}/`,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          is_active: survey.is_active
        }
      }
      axios(config)
        .then(response => {
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('msg_survey_updated'))
        })
        .catch(error => {
          survey.is_active = !survey.is_active // revert on error
          console.error(error)
        })
    },
    openQuestionsDialog (survey) {
      this.selectedSurvey = survey
      this.questionsData = []
      let startingOrder = 1
      if (survey.questions && survey.questions.length > 0) {
        startingOrder = survey.questions.length + 1
      }
      this.addQuestion(startingOrder)
      this.dialogQuestions = true
    },
    addQuestion (order = null) {
      this.questionsData.push({
        text: '',
        question_type: 'SINGLE_CHOICE',
        order: order || this.questionsData.length + 1,
        options: [{ text: '', order: 1 }, { text: '', order: 2 }]
      })
    },
    removeQuestion (index) {
      this.questionsData.splice(index, 1)
    },
    addOption (qIndex) {
      const q = this.questionsData[qIndex]
      q.options.push({ text: '', order: q.options.length + 1 })
    },
    removeOption (qIndex, oIndex) {
      this.questionsData[qIndex].options.splice(oIndex, 1)
    },
    saveQuestions () {
      this.loading = true
      const config = {
        method: 'post',
        url: `https://residencial-services.intrare.app/admin/surveys/${this.selectedSurvey.id}/add_questions/`,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          questions: this.questionsData.map(q => {
            let parsedQ = {
              text: q.text,
              question_type: q.question_type,
              order: q.order
            }
            if (q.question_type === 'SINGLE_CHOICE' || q.question_type === 'MULTIPLE_CHOICE') {
              parsedQ.options = q.options.map((o, idx) => ({ text: o.text, order: idx + 1 }))
            }
            return parsedQ
          })
        }
      }
      axios(config)
        .then(response => {
          this.loading = false
          this.dialogQuestions = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('msg_questions_added'))
          this.getSurveys()
        })
        .catch(error => {
          this.loading = false
          console.error(error)
        })
    },
    viewResults (survey) {
      this.selectedSurvey = survey
      this.resultsData = {}
      const config = {
        method: 'get',
        url: `https://residencial-services.intrare.app/admin/surveys/${survey.id}/results/`,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.resultsData = response.data
          this.dialogResults = true
        })
        .catch(error => {
          console.error(error)
        })
    },
    async downloadPDF (survey) {
      this.$store.commit('snackbar_activate_true')
      this.$store.commit('snackbar_change_message', 'Generando PDF...')
      try {
        const config = {
          method: 'get',
          url: `https://residencial-services.intrare.app/admin/surveys/${survey.id}/results/`,
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': this.language,
            'authorization': 'Token ' + store.getters.getToken
          }
        }
        const response = await axios(config)
        const results = response.data.results
        const doc = new JsPDF()
        doc.setFontSize(18)
        doc.text(`Reporte de Encuesta: ${survey.title}`, 14, 20)
        doc.setFontSize(12)
        const d = new Date()
        const day = String(d.getDate()).padStart(2, '0')
        const month = String(d.getMonth() + 1).padStart(2, '0')
        const year = d.getFullYear()
        const formattedDate = `${day}/${month}/${year}`
        doc.text(`Fecha: ${formattedDate}`, 14, 30)
        let yPos = 40
        let qIndex = 1
        for (const qText in results) {
          if (yPos > 250) {
            doc.addPage()
            yPos = 20
          }
          doc.setFontSize(14)
          doc.text(`${qIndex}. ${qText}`, 14, yPos)
          yPos += 10
          const res = results[qText]
          if (!Array.isArray(res)) {
            const labels = Object.keys(res)
            const dataValues = Object.values(res)
            doc.autoTable({
              startY: yPos,
              head: [['Opción', 'Total']],
              body: labels.map(label => [label, res[label]]),
              margin: { left: 14 }
            })
            yPos = doc.lastAutoTable.finalY + 10
            // Create Pie Chart
            if (labels.length > 0) {
              const canvas = document.createElement('canvas')
              canvas.width = 400
              canvas.height = 300
              document.body.appendChild(canvas)
              const ctx = canvas.getContext('2d')
              const chart = new Chart(ctx, {
                type: 'pie',
                data: {
                  labels: labels,
                  datasets: [{
                    data: dataValues,
                    backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40', '#E7E9ED', '#8AC24A']
                  }]
                },
                options: {
                  animation: false,
                  responsive: false
                }
              })
              const imgData = canvas.toDataURL('image/png')
              chart.destroy()
              if (yPos + 80 > 280) {
                doc.addPage()
                yPos = 20
              }
              doc.addImage(imgData, 'PNG', 14, yPos, 100, 75)
              yPos += 85
              document.body.removeChild(canvas)
            }
          } else {
            // Text Responses
            const body = res.length > 0 ? res.map(text => [text]) : [['No hay respuestas']]
            doc.autoTable({
              startY: yPos,
              head: [['Respuestas']],
              body: body,
              margin: { left: 14 }
            })
            yPos = doc.lastAutoTable.finalY + 10
          }
          qIndex++
        }
        const fileDate = `${day}-${month}-${year}`
        const safeTitle = survey.title.replace(/[^a-z0-9]/gi, '_').toLowerCase()
        doc.save(`${safeTitle}_${fileDate}.pdf`)
      } catch (error) {
        console.error(error)
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', 'Error al generar PDF')
      }
    },
    previewSurvey (survey) {
      this.selectedSurvey = survey
      this.dialogPreview = true
    }
  }
}
</script>

<style scoped>
.p-3 { padding: 12px; }
.mb-5 { margin-bottom: 20px; }
.mb-4 { margin-bottom: 16px; }
.ml-5 { margin-left: 20px; }
.mt-2 { margin-top: 8px; }
</style>
